/** Saved valid concepts remain reviewable when a bounded planning run is partial. */
export function conceptCompletion(saved: number, requested: number, productName: string, autoBuild: boolean) {
  const missing = Math.max(0, requested - saved);
  const success = missing === 0;
  return {
    success,
    autoBuild: autoBuild && success,
    summary: success
      ? `${saved} concept${saved === 1 ? '' : 's'} ready for ${productName}.`
      : `${saved} of ${requested} concepts saved for ${productName}. The set is incomplete: ${missing} could not be completed after validation retries. Your saved concepts are available to review.`,
  };
}
